import { atom } from "@reatom/framework";

export const clientIdAtom = atom<string | undefined>(undefined, "clientIdAtom");
